import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { FormRenderContext } from "../features/form/FormRenderContext.js";
import { AwaitContext } from "../shared/contexts/AwaitContext.js";
import { OfferRenderContext } from "../features/offer/OfferRenderContext.js";
export function CommandRenderer({ command, children }) {
    const formValue = useMemo(() => command?.kind === "renderForm" ? { form: command.form, data: command.prefilledData } : {}, [command]);
    const offerValue = useMemo(() => (command?.kind === "renderOffer" ? { offer: command.offer } : {}), [command]);
    const awaitValue = useMemo(() => ({ isAwaiting: command?.kind === "await" }), [command]);
    return (_jsx(FormRenderContext.Provider, { value: formValue, children: _jsx(OfferRenderContext.Provider, { value: offerValue, children: _jsx(AwaitContext.Provider, { value: awaitValue, children: command?.kind === "redirect" ? null : children }) }) }));
}
